export default __webpack_public_path__ + "device-portal-splash.png";